<div class="scroll-to-top" [class.show-scrollTop]="windowScrolled()">
  @if (windowScrolled()) {
    <button
      type="button"
      class="btn active"
      data-toggle="button"
      (click)="scrollToTop()"
    >
      <i nz-icon [nzType]="svg_icon_top" class="svg-icon arrow-top"></i>
      <span class="wrap-text">{{ i18n.langString("back_to_top") }}</span>
    </button>
  }
</div>
